import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule, MatIcon],
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.css'],
})
export class CookieConsentComponent implements OnInit {
  isCookieAccepted = false;
  isCookieDismissed = false;
  showPopup = false;

  @Output() popupClosed = new EventEmitter<void>();

  ngOnInit(): void {
    this.isCookieAccepted = this.checkCookieConsent();
    this.isCookieDismissed = this.checkCookieDismissal();

    if (!this.isCookieAccepted && !this.isCookieDismissed) {
      this.showPopup = true;
    }
  }

  checkCookieConsent(): boolean {
    return localStorage.getItem('cookie-consent') === 'accepted';
  }

  checkCookieDismissal(): boolean {
    return sessionStorage.getItem('cookie-dismissed') === 'true';
  }

  acceptCookies(): void {
    localStorage.setItem('cookie-consent', 'accepted');
    this.showPopup = false;
    this.emitPopupClosed();
  }

  rejectCookies(): void {
    sessionStorage.setItem('cookie-dismissed', 'true');
    this.showPopup = false;
    this.emitPopupClosed();
  }

  private emitPopupClosed(): void {
    this.popupClosed.emit();
  }
}
